export default {"src":"/_next/static/media/NRDS.19c4f67a.svg","height":18,"width":18};